module.exports = __webpack_public_path__ + "static/media/aura.e91269f3.png";